import type { FaireProductEntity } from "../../entity_types/product";

export const p_6s8wgdsetz: FaireProductEntity = {
  token: "p_6s8wgdsetz",
  type: "product",
  name: "Hot Cocoa Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/3437f20797ea48cf6d6ac2da61b9e494e8d2f7fe7e5983c52ba39d9a7f2f4ab8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f769677f909588fa33ce10a95b76e2e6e149e32fe5e7d4e9b773d3cb28c5f47c.jpeg",
    "https://cdn.faire.com/fastly/639c4d74b45752c43d78292744264b57fbce44b2c089d571477e184e9d856c9e.jpeg",
    "https://cdn.faire.com/fastly/4bb67a4470f1285809772120a72b41cdcffe1d3b21a7bdc5a6c6c40c45511a76.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:09.001Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
